import { PaymentsState } from './types'

export const state: PaymentsState = {
  payments: []
}
